<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Redenen nafacturatie" />
        </template>

        <template #pageContent>
            <div class="flex justify-between w-1/2">
                <TableSearch tableId="configuration-post-invoice-reasons" :values="postInvoiceReasons" class="w-1/2" placeholder="Zoeken"/>

                <Modal buttonText="Toevoegen" buttonClass="add" ref="modal">
                    <h2>Nafacturatie reden {{ modalTitleAction }}</h2>
                    <Form @submitted="handleSubmit" class="w-full">
                        <Input type="hidden" name="id" v-model="form.id" />
                        <Input type="text" label="Reden" name="reason" :required="true" v-model="form.reason" :error="form.errors.reason" />

                        <div class="inline-block self-end mt-4">
                            <Button text="Annuleren" buttonClass="secondary" data-modal="close" @click="form.reset()" />
                            <Button
                                :text="modalTitleAction"
                                buttonType="submit"
                                buttonClass="save"
                                class="capitalize"
                                :loading="form.processing"
                            />
                        </div>
                    </Form>
                </Modal>
            </div>

            <Table id="configuration-post-invoice-reasons" :values="postInvoiceReasons" class="w-1/2">
                <thead>
                    <Th id="reason">Reden</th>
                    <Th :sort="false" class="w-[75px]"></Th>
                </thead>
                <tbody>
                <tr v-for="(postInvoiceReason, key) in state.sortedValues['configuration-post-invoice-reasons']" :key="key">
                    <Td>{{ postInvoiceReason.reason }}</Td>
                    <Td>
                        <Button buttonClass="edit" size="small" title="Bewerken" @click="updatePostInvoiceReason(postInvoiceReason)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deletePostInvoiceReason(postInvoiceReason)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import store from '@/store'
import { useForm } from "@inertiajs/inertia-vue3"
import { onMounted, ref, watch} from "vue"
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Form,
        Input,
    },
    props: [
        'postInvoiceReasons',
    ],
    setup (props)
    {
        let modalTitleAction = ref('toevoegen') //of bewerken
        const modal = ref(null)

        const form = useForm({
            id: null,
            reason: null,
        })

        function updatePostInvoiceReason(postInvoiceReason)
        {
            form.id = postInvoiceReason.id
            form.reason = postInvoiceReason.reason

            modalTitleAction.value = 'bewerken'
            modal.value.show = true
        }

        function deletePostInvoiceReason(postInvoiceReason)
        {
            if (!confirm('Bent u zeker dat u deze nafacturatie reden wil verwijderen?'))
                return

            Inertia.delete('/configuration/post_invoice_reasons/' + postInvoiceReason.id)
        }

        function handleSubmit()
        {
            if (modalTitleAction.value == 'toevoegen')
            {
                //Store
                form.post('/configuration/post_invoice_reasons', {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            } else {
                //Update
                form.put('/configuration/post_invoice_reasons/' + form.id, {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            }
        }

        onMounted(() => {
            //Check if modal gets closed
            watch(() => modal.value.show, (modalShow, prevModalShow) => {
                if (!modalShow) {
                    //Reset to default values
                    setTimeout(function() {
                            modalTitleAction.value = 'toevoegen'
                            form.clearErrors()
                            form.reset()
                        },
                        500
                    );
                }
            })
        })

        return {
            state: store.state,
            ...store,
            form,
            handleSubmit,
            modal,
            modalTitleAction,
            updatePostInvoiceReason,
            deletePostInvoiceReason,
        }
    },
}

</script>
